import React, { Fragment, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClickAway } from 'react-use';
import { styled } from 'styled-components';
import { SearchOrderDialog } from './SearchOrderDialog';
import SvgOrder from '../../../../../play-core/icons/Order';
import { TransparentButton } from '../../../components/ClickableComponents/Button';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useSearchDispatch } from '../SearchContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchOrder = ({
  selected
}) => {
  const {
    t
  } = useTranslation();
  const defaultTitle = t('search.orderRelevant');
  const defaultItem = {
    id: 'relevant',
    title: defaultTitle
  };
  const items = [defaultItem, {
    id: 'desc',
    title: t('search.orderNewest')
  }];
  const {
    supportSearchOrder
  } = useVideoConfig();
  const selectedItem = items.find(value => value.id === selected) || defaultItem;
  const title = selectedItem?.title || defaultTitle;
  const dispatch = useSearchDispatch();
  const dialogRef = useRef(null);
  useClickAway(dialogRef, () => setOrderDialog(false));
  const [showOrderDialog, setOrderDialog] = useState(false);
  return /*#__PURE__*/_jsx(Fragment, {
    children: supportSearchOrder && /*#__PURE__*/_jsx(PlayContainer, {
      width: "small",
      children: /*#__PURE__*/_jsxs(Layout, {
        ref: dialogRef,
        children: [/*#__PURE__*/_jsx(TransparentButton, {
          type: "text",
          text: title,
          onClick: () => setOrderDialog(!showOrderDialog),
          icon: /*#__PURE__*/_jsx(SvgOrder, {})
        }), /*#__PURE__*/_jsx(SearchOrderDialog, {
          selected: selectedItem,
          onCloseClick: () => setOrderDialog(false),
          show: showOrderDialog,
          onSelection: id => {
            dispatch({
              type: 'set-order',
              order: id
            });
            setOrderDialog(false);
          },
          items: items
        })]
      })
    })
  });
};

// Important --> do not change to div. this would apply the style from StyledSearchFilters for some reason
const Layout = styled.section.withConfig({
  displayName: "SearchOrder__Layout",
  componentId: "sc-5za9fu-0"
})(["position:relative;max-width:1088px;display:grid;justify-content:end;"]);